/**
 * This function maps a domain to a product name. It is a temporary solution until the mapping is consistent.
 *
 * @param domain The domain to map to a product name
 * @returns The corresponding product name for the given domain
 */
export const mapDomainToProduct = (domain: string): string => {
  switch (domain) {
    case 'dataaihub':
      return 'data-ai-hub';
    case 'eiot':
      return 'eiot';
    case 'griddata':
      return 'grid-structure';
    case 'gridhub':
      return 'grid-calculation';
    case 'mediadataplatform':
      return 'media-data';
    default:
      return domain;
  }
};
